import React, {useCallback, useEffect, useState} from "react";
import {Button, DatePicker, Form, Input, NavBar, Picker, Selector, Toast} from "antd-mobile";
import {useLocation, useNavigate} from "react-router-dom";
import dayjs from 'dayjs'
import moment from "moment";
import {TOASTDURATION} from "../../common/Utils";
import {codeCity, codeCountry, modifyOrderInfo} from "../../common/ApiAction";
import {useTranslation} from "react-i18next";

type pickerType = {
    label: string,
    value: string
}

const operatorLockList = [
    {
        label: 'No',
        value: '0'
    },
    {
        label: 'Yes',
        value: '1'
    }
]

const orderTypeList = [
    {
        label: 'Internal',
        value: 'Internal'
    },
    {
        label: 'External_1',
        value: 'External_1'
    },
    {
        label: '1',
        value: '1'
    },
    {
        label: '2',
        value: '2'
    },
    {
        label: '3',
        value: '3'
    }
]


const EditOrder = () => {

    const navigate = useNavigate();
    const [form] = Form.useForm();
    const location = useLocation();
    const { t } = useTranslation();
    const [countList, setCountList] = useState<pickerType[]>([]);
    const [cityParentId, setCityParentId] = useState('100000');
    const [districtList, setDistrictList] = useState<pickerType[]>([]);
    const [districtParentId, setDistrictParentId] = useState('100000');
    const [cityList, setCityList] = useState<pickerType[]>([]);
    const loanDaysList = [
        {
            label: t('create_order_loan_3_months'), // 使用翻译
            value: "1"
        },
        {
            label: t('create_order_loan_6_months_24'), // 使用翻译
            value: "2"
        },
        {
            label: t('create_order_loan_6_months_12'), // 使用翻译
            value: "3"
        },
        {
            label: t('create_order_loan_4_months'), // 使用翻译
            value: "4"
        },
        {
            label: t('create_order_loan_5_months'), // 使用翻译
            value: "5"
        },
        {
            label: t('create_order_loan_1_months'), // 使用翻译
            value: "6"
        },
        {
            label: t('create_order_loan_2_months'), // 使用翻译
            value: "7"
        }
    ]

    useEffect(() => {
        codeCity({parentId: cityParentId}).then((res: any) => {
            if (!res.executed) {
                Toast.show({icon: 'fail', content: res.message, duration: TOASTDURATION})
            } else {
                const list: pickerType[] = [];
                res.data.forEach((e: any) => {
                    const item: pickerType = {
                        label: e.enName,
                        value: e.cityCodeId
                    }
                    list.push(item);
                });
                setCityList(list);
            }
        })
    }, [cityParentId]);
    useEffect(() => {
        codeCity({parentId: districtParentId}).then((res: any) => {
            if (!res.executed) {
                Toast.show({icon: 'fail', content: res.message, duration: TOASTDURATION})
            } else {
                const list: pickerType[] = [];
                res.data.forEach((e: any) => {
                    const item: pickerType = {
                        label: e.enName,
                        value: e.cityCodeId
                    }
                    list.push(item);
                });
                setDistrictList(list);
            }
        })
    },[districtParentId])
    const _makeShowData = useCallback(() => {
        const data = location.state;
        const keyIgnoreList = ['rawCreateTime','rawUpdateTime','periods', 'singlePeriodDay']
        if (data) {
            const resData = {};
            Object.keys(data).forEach(key => {
                if (key !== 'approvalInfo') {
                    const dataItem = data[key];
                    if (dataItem) {
                        Object.keys(dataItem).forEach(key2 => {
                            console.log(key, key2)
                            if (key2 === 'periods') {
                                const loanDaysTem = _getOrderLoadDays(dataItem.periods, dataItem.singlePeriodDay)
                                if (loanDaysTem) {
                                    // @ts-ignore
                                    resData['orderInfo.loanDaysType'] = loanDaysTem
                                }
                                return;
                            }
                            if (key2 === 'operatorLock') {
                                console.log(dataItem[key2])
                                // @ts-ignore
                                resData['productInfo.operatorLock'] = parseInt(dataItem[key2]) === 1 ? '1' : '0'
                                return
                            }
                            if (key2 === 'appleId') {
                                // @ts-ignore
                                resData['productInfo.serialNumber'] = dataItem[key2]
                                return
                            }
                            if (key2 === 'countryCode' || key2 === 'cityCode' || key2 === 'districtCode') {
                                return
                            }
                            if (key2 === 'contractDate') {
                                const itemTmm: Date = new Date(dataItem[key2])
                                // @ts-ignore
                                resData['orderInfo.contractDate'] = itemTmm
                                return
                            }
                            if (keyIgnoreList.includes(key2)) {
                                return
                            }
                            const keyTem: string = key + "." + key2;
                            if (dataItem[key2]) {
                                // @ts-ignore
                                resData[keyTem] = dataItem[key2]
                            }
                        })
                    }
                }
            })
            form.setFieldsValue(resData);
        }
    }, [form, location.state]);
    useEffect(() => {
        _getCodeCountry();
        _makeShowData();
    }, [_makeShowData]);

    const _getOrderLoadDays = (periods: number, singlePeriodDay: number): string | null => {
        if (periods === 12 && singlePeriodDay === 7) {
            return "1"
        } else if (periods === 24 && singlePeriodDay === 7) {
            return "2"
        } else if (periods === 12 && singlePeriodDay === 14) {
            return "3"
        } else if (periods === 16 && singlePeriodDay === 7) {
            return "4"
        } else if (periods === 20 && singlePeriodDay === 7) {
            return "5"
        } else if (periods === 4 && singlePeriodDay === 7) {
            return "6"
        } else if (periods === 8 && singlePeriodDay === 7) {
            return "7"
        } else {
            return null
        }
    }
    const _getCodeCountry = () => {
        codeCountry().then((res: any) => {
            if (!res.executed) {
                Toast.show({icon: 'fail', content: res.message, duration: TOASTDURATION})
            } else {
                const list: pickerType[] = [];
                res.data.forEach((e: any) => {
                    const item: pickerType = {
                        label: e.enName,
                        value: e.cityCodeId as string
                    }
                    list.push(item);
                });
                setCountList(list);
            }
        })
    }
    const back = () => {
        navigate(-1);
    };
    const _getcountryDesc = (val: any, isCity: boolean) => {
        if (Array.isArray(val) && val.length > 0) {
            const item = val[0];
            if (item) {
                if (!isCity) {
                    setCityParentId(item.value)
                }
                return item.label
            }
        }
        return t('create_order_select');
    }
    const _getDistrictDesc = (val: any) => {
        if (Object.keys(val).length) {
            const item = val[0];
            if (item) {
                setDistrictParentId(item.value)
                return item.label
            }
        }
        return t('create_order_select');
    }
    const _getCommonDesc = (val: any) => {
        if (Object.keys(val).length) {
            const item = val[0];
            if (item) {
                return item.label
            }
        }
        return t('create_order_select');
    }
    const onFinish = (values: any) => {
        if (values['orderInfo.contractDate']) {
            values['orderInfo.contractDate'] = moment(values['orderInfo.contractDate']).format('YYYY-MM-DD')
        }
        if (values['orderInfo.loanDaysType']) {
            values['orderInfo.loanDaysType'] = values['orderInfo.loanDaysType'][0];
        }
        if (values['orderInfo.orderType']) {
            values['orderInfo.orderType'] = values['orderInfo.orderType'][0];
        }
        if (values['productInfo.operatorLock']) {
            values['productInfo.operatorLock'] = values['productInfo.operatorLock'][0];
        }
        if (values['orderInfo.countryCode']) {
            values['orderInfo.countryCode'] = values['orderInfo.countryCode'][0];
        }
        if (values['orderInfo.cityCode']) {
            values['orderInfo.cityCode'] = values['orderInfo.cityCode'][0];
        }
        if (values['orderInfo.districtCode']) {
            values['orderInfo.districtCode'] = values['orderInfo.districtCode'][0];
        }
        const result = {};
        for (const key in values) {
            const keys = key.split('.');
            keys.reduce((acc: any, cur, idx) => {
                if (idx === keys.length - 1) {
                    acc[cur] = values[key];
                } else {
                    acc[cur] = acc[cur] || {};
                }
                return acc[cur];
            }, result);
        }
        console.log(result)
        Toast.show({icon: 'loading', content: 'Login...', duration: 0})
        modifyOrderInfo(result).then((res: any) => {
            Toast.clear();
            if (!res.executed) {
                Toast.show({icon: 'fail', content: res.message, duration: TOASTDURATION})
            } else {
                Toast.show({
                    content: 'Modify Order Success',
                    duration: TOASTDURATION,
                    icon: 'success',
                    afterClose: () => {
                        navigate(-1);
                    }
                });
            }
        }).catch(err => {
            Toast.clear();
        })
    }
    /**
     * 姓名，身份证号，年龄，手机号码 ,紧急联系人，紧急联系人电话
     * 手机型号，内存，颜色，序列码
     * 商户名称，业务员
     * 商品金额，首付金额，租赁周期
     */
    return <div style={{display: "flex", flexDirection: "column", width: '100%', backgroundColor: '#F5F6FA'}}>
        <NavBar style={{backgroundColor: '#FFF'}} onBack={back}>{t('create_order_title')}</NavBar>
        <div>
            <Form
                onFinish={onFinish}
                mode={'card'}
                form={form}
                requiredMarkStyle='asterisk'
                footer={<Button shape='rounded' type='submit' block color='primary' size='middle'>{t('create_order_submit')}</Button>}>
                <Form.Header>{t('common_ordere_no')}</Form.Header>
                <Form.Item name='orderInfo.orderNo' label={t('common_ordere_no')} rules={[{ required: true, message: t('common_ordere_no') }]}>
                    <Input disabled placeholder={t('common_ordere_no')} />
                </Form.Item>
                <Form.Header>{t('create_order_user_info')}</Form.Header>
                <Form.Item name='userInfo.userName' label={t('create_order_user_name')} rules={[{ required: true, message: t('create_order_required') }]}>
                    <Input placeholder={t('create_order_required')} />
                </Form.Item>
                <Form.Item name='userInfo.mobile' label={t('create_order_user_mobile')} rules={[{ required: true, message: t('create_order_required') }]}>
                    <Input placeholder={t('create_order_required')} />
                </Form.Item>
                <Form.Item name='userInfo.idNum' label={t('create_order_id_number')}>
                    <Input placeholder={t('create_order_required')} />
                </Form.Item>
                <Form.Item name='userInfo.address' label={t('create_order_address')}>
                    <Input placeholder={t('create_order_required')} />
                </Form.Item>
                <Form.Item name='userInfo.email' label={t('create_order_email')}>
                    <Input placeholder={t('create_order_required')} />
                </Form.Item>
                <Form.Item name='userInfo.staff' label={t('create_order_staff')}>
                    <Input placeholder={t('create_order_required')} />
                </Form.Item>
                <Form.Item name='userInfo.emergencyContact' label={t('create_order_emergency_contact')}>
                    <Input placeholder={t('create_order_required')} />
                </Form.Item>
                <Form.Item name='userInfo.emergencyMobile' label={t('create_order_emergency_mobile')}>
                    <Input placeholder={t('create_order_required')} />
                </Form.Item>
                <Form.Header>{t('create_order_product_info')}</Form.Header>
                <Form.Item name='productInfo.model' label={t('create_order_product_name')} rules={[{ required: true, message: t('create_order_required') }]}>
                    <Input placeholder={t('create_order_required')} />
                </Form.Item>
                <Form.Item name='productInfo.serialNumber' label={t('create_order_product_serial_number')} rules={[{ required: true, message: t('create_order_required') }]}>
                    <Input placeholder={t('create_order_required')} />
                </Form.Item>
                <Form.Item name='productInfo.operatorLock' label={t('create_order_product_operator_lock')}>
                    <Selector options={operatorLockList} />
                </Form.Item>
                <Form.Item name='productInfo.memorySize' label={t('create_order_product_memory_size')}>
                    <Input placeholder={t('create_order_required')} />
                </Form.Item>
                <Form.Item name='productInfo.color' label={t('create_order_product_color')}>
                    <Input placeholder={t('create_order_required')} />
                </Form.Item>
                <Form.Item name='productInfo.imei' label={t('create_order_product_imei')}>
                    <Input placeholder={t('create_order_required')} />
                </Form.Item>
                <Form.Item name='productInfo.merchant' label={t('create_order_product_merchant')}>
                    <Input placeholder={t('create_order_required')} />
                </Form.Item>
                <Form.Header>{t('create_order_order_info')}</Form.Header>
                <Form.Item name='orderInfo.price' label={t('create_order_order_price')} rules={[{ required: true, message: t('create_order_required') }]}>
                    <Input type={"number"} placeholder={t('create_order_required')} />
                </Form.Item>
                <Form.Item name='orderInfo.downPayment' label={t('create_order_down_payment')} rules={[{ required: true, message: t('create_order_required') }]}>
                    <Input type={"number"} placeholder={t('create_order_required')} />
                </Form.Item>
                <Form.Item
                    name='orderInfo.contractDate'
                    label={t('create_order_contract_date')}
                    trigger='onConfirm'
                    onClick={(e, datePickerRef) => {
                        datePickerRef.current?.open();
                    }}
                    rules={[{ required: true, message: t('create_order_required') }]}>
                    <DatePicker>
                        {value => value ? dayjs(value).format('YYYY-MM-DD') : t('create_order_select_date')}
                    </DatePicker>
                </Form.Item>
                <Form.Item
                    name='orderInfo.countryCode'
                    label={t('create_order_country')}
                    trigger='onConfirm'
                    onClick={(e, pickerRef) => {
                        pickerRef.current?.open();
                    }}
                    rules={[{ required: false, message: t('create_order_required') }]}>
                    <Picker columns={[countList]}>
                        {value => value ? _getcountryDesc(value, false) : t('create_order_country')}
                    </Picker>
                </Form.Item>
                <Form.Item
                    name='orderInfo.cityCode'
                    label={t('create_order_city')}
                    trigger='onConfirm'
                    onClick={(e, pickerRef) => {
                        pickerRef.current?.open();
                    }}
                    rules={[{ required: false, message: t('create_order_required') }]}>
                    <Picker columns={[cityList]}>
                        {value => value ? _getDistrictDesc(value) : t('create_order_city')}
                    </Picker>
                </Form.Item>
                <Form.Item
                    name='orderInfo.districtCode'
                    label={t('create_order_district')}
                    trigger='onConfirm'
                    onClick={(e, pickerRef) => {
                        pickerRef.current?.open();
                    }}
                    rules={[{ required: false, message: t('create_order_required') }]}>
                    <Picker columns={[districtList]}>
                        {value => value ? _getCommonDesc(value) : t('create_order_district')}
                    </Picker>
                </Form.Item>
                <Form.Item
                    name='orderInfo.orderType'
                    label={t('create_order_order_type')}
                    rules={[{ required: true, message: t('create_order_select_order_type') }]}>
                    <Selector options={orderTypeList} />
                </Form.Item>
                <Form.Item name='orderInfo.loanDaysType' label={t('create_order_loan_days')} rules={[{ required: true, message: t('create_order_select_loan_days') }]}>
                    <Selector options={loanDaysList} />
                </Form.Item>
            </Form>
        </div>
    </div>
}
export default EditOrder;
